import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { exhaustMap, of } from 'rxjs';
import { AvaActions } from '../actions/ava.actions';
import { State } from '../index';
import { AppGatewayService } from '../../services/app-gateway.service';
import { isNotNullOrUndefined } from '../../../helper/helper';
import { getAvaDictionary } from '../selectors/ava.selector';
import { AvaDataService } from '../../../ava/services/ava-data.service';
import { catchError, concatMap, map, withLatestFrom } from 'rxjs/operators';
import { BaseActionTypes } from '../actions/base.actions';

enum ErrorCodes {
    Load = 'AVA Abrufen fehlgeschlagen',
    Modify = 'AVA Bearbeiten fehlgeschlagen',
    Remove = 'AVA Löschen fehlgeschlagen',
    Add = 'AVA Hinzufügen fehlgeschlagen',
}

@Injectable()
export class AvaEffects {
    GetAva = createEffect(
        () =>
            this.actions$.pipe(
                ofType(AvaActions.loadRequest),
                exhaustMap(({ Payload }) => {
                    return this.api.get$({ UpdatedSince: Payload.updatedSince }).pipe(
                        withLatestFrom(this.store$.select(getAvaDictionary)),
                        map(([res, state]) => {
                            if (!isNotNullOrUndefined(Payload.updatedSince)) {
                                return AvaActions.loadSuccess({ Payload: res });
                            } else {
                                const fRes = res.filter((p) => {
                                    const fromState = state[p.Id];
                                    return !fromState || fromState.UpdatedAt.getTime() !== p.UpdatedAt.getTime();
                                });
                                return AvaActions.loadSuccess({ Payload: fRes });
                            }
                        }),
                        catchError(err => of(AvaActions.loadFailure({ Errors: err, ToasterMessage: ErrorCodes.Load }))),
                    );
                }),
            ),
    );
    EditAva = createEffect(() =>
        this.actions$.pipe(
            ofType(AvaActions.changeRequest),
            concatMap(({ Payload }) => this.api.change$(Payload).pipe(
                    map((res) => AvaActions.changeSuccess({ Payload: res })),
                    catchError(err => of(AvaActions.changeFailure({ Errors: err, ToasterMessage: ErrorCodes.Modify }))),
                )
            )
        ),
    );
    AddAva = createEffect(() =>
        this.actions$.pipe(
            ofType(AvaActions.addRequest),
            concatMap(({ Payload }) => this.api.add$(Payload).pipe(
                    map((res) => AvaActions.addSuccess({ Payload: res })),
                    catchError(err => of(AvaActions.addFailure({ Errors: err, ToasterMessage: ErrorCodes.Add }))),
                )
            )
        ),
    );
    DeleteAva = createEffect(() =>
        this.actions$.pipe(
            ofType(AvaActions.deleteRequest),
            concatMap(({ Payload }) => this.api.delete$(Payload).pipe(
                    map((res) => AvaActions.deleteSuccess({ Payload: +res.Id })),
                    catchError(err => of(AvaActions.deleteFailure({ Errors: err, ToasterMessage: ErrorCodes.Remove }))),
                )
            )
        ),
    );
    constructor(private actions$: Actions, private store$: Store<State>, private gatewayService: AppGatewayService, private api: AvaDataService/*private avaResolver: AvaResolver*/) {
    }

    Error = createEffect(
        () =>
            this.actions$.pipe(
                ofType(AvaActions.loadFailure, AvaActions.addFailure, AvaActions.changeFailure, AvaActions.deleteFailure),
                map(({ Errors, ToasterMessage }) => BaseActionTypes.ErrorAction({
                    Payload: {
                        ToasterMessage,
                        Err: Errors,
                    },
                })),
            ),
    );
}
